import { FeatureWebP } from '../constants/featureWebP';
import { ImageFormat } from '../constants/imageFormat';

export const deviceMixin = {
  data() {
    return {
      isMounted: false,
      isMobile: false,
      supportWebP: false,
    };
  },
  computed: {
    imageFormat(): ImageFormat | undefined {
      const self: any = this;
      if (!self.isMounted) {
        return undefined;
      }
      if (self.supportWebP) {
        if (self.isMobile) {
          return ImageFormat.MobileWebP;
        } else {
          return ImageFormat.DesktopWebP;
        }
      } else {
        if (self.isMobile) {
          return ImageFormat.MobileJpeg;
        }
      }
      return ImageFormat.DesktopJpeg;
    },
  },
  mounted() {
    const self: any = this;
    self.isMobile = self.hasTouchScreen();
    self.checkWebPFeature(FeatureWebP.LossLess, function(result: boolean) {
      self.supportWebP = result;
      self.isMounted = true;
    });
  },
  methods: {
    hasTouchScreen(): boolean {
      let hasTouchScreen = false;
      if ('maxTouchPoints' in navigator) {
        hasTouchScreen = navigator.maxTouchPoints > 0;
      } else if ('msMaxTouchPoints' in navigator) {
        hasTouchScreen = (navigator as any).msMaxTouchPoints > 0;
      } else {
        const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
        if (mQ && mQ.media === '(pointer:coarse)') {
          hasTouchScreen = mQ.matches;
        } else if ('orientation' in window) {
          hasTouchScreen = true; // deprecated, but good fallback
        } else {
          const UA = (navigator as any).userAgent;
          hasTouchScreen =
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
        }
      }
      return hasTouchScreen;
    },
    checkWebPFeature(feature: FeatureWebP, callback: Function): void {
      const kTestImages = {
        lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
        lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
        alpha:
          'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
        animation:
          'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
      };
      const img = new Image();
      img.onload = function() {
        var result = img.width > 0 && img.height > 0;
        callback(result);
      };
      img.onerror = function() {
        callback(false);
      };
      img.src = 'data:image/webp;base64,' + kTestImages[feature];
    },
  },
};
